// `contact-sync.seed_requested.v1` — emitted by marketing-backend after a
// PocketFlows Business is provisioned for an org (via tRPC enableMarketingTier
// or the accounts→marketing subscription-activated webhook). Consumed by
// the marketing worker's `seed-contacts-for-business` Inngest function to
// kick off the initial bulk push of opted-in contacts to PocketFlows.
//
// Producer: marketing-backend (this same lambdalith).
// Consumer: marketing-backend worker.
//
// This is the M-4.1 *initial seed* event. The ongoing live drain (Dirty
// Flag + Drain, scheduled cron) is a separate path that does NOT consume
// this event — it queries dirty contacts directly. Seed = one-shot at
// provisioning; drain = steady-state.
//
// detailType in EventBridge: `contact-sync.seed_requested.v1`.

import { z } from 'zod';

import { eventEnvelopeSchema } from './base.js';

export const contactSyncSeedRequestedV1Schema = eventEnvelopeSchema.extend({
  // PocketFlows Business ID the seeded customers will be pushed under.
  // Stored on `organizations.pocketflow_business_id` at provisioning time.
  pocketflowBusinessId: z.string().min(1).max(256),
  // Denormalized org name for log/Sentry triage when an operator opens a
  // status row by runId. Strictly optional — the workflow re-resolves the
  // org via OrganizationRepository on dispatch.
  organizationName: z.string().min(1).max(512).optional(),
});

export type ContactSyncSeedRequestedV1 = z.infer<
  typeof contactSyncSeedRequestedV1Schema
>;

export const CONTACT_SYNC_SEED_REQUESTED_V1_DETAIL_TYPE =
  'contact-sync.seed_requested.v1' as const;
